import { useParams } from 'react-router-dom'
import get from 'lodash/get'
import { useGetVideoByIdQuery } from '../store/api'
import YoutubeQuestioner from './YoutubeQuestioner'
import { Title, RoundLink, TextBox, JustifySpaceBetween, UnstyledRouterLink } from '../styled'

export default function AsidePlayer() {
  const { id } = useParams()
  const videoQuery = useGetVideoByIdQuery(id, { skip: !id })
  const videoData = get(videoQuery, 'data') || {}
  const { title, questions, videoId } = videoData

  const linkToVideo = `/video/${id}`

  return (
    <>
      <Title>{title}</Title>
      <YoutubeQuestioner youtubeId={videoId} questions={questions} />
      <h3>Share Link</h3>
      <JustifySpaceBetween mb={16}>
        <div>
          <TextBox>{`${window.location.origin}${linkToVideo}`}</TextBox>
        </div>
        <RoundLink to="#">Copy</RoundLink>
        <RoundLink to={linkToVideo}>Go!</RoundLink>
      </JustifySpaceBetween>
      <UnstyledRouterLink mb={20} to={'/videos'}>
        Close
      </UnstyledRouterLink>
    </>
  )
}
